var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnedriveSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.47502 22.55L18.125 15.625L9.75002 10.675C9.75002 10.675 9.00002 10.25 7.82502 10.1C3.50002 10.2 0.0250244 13.725 0.0250244 18.075C0.0250244 19.8 0.575024 21.4 1.50002 22.7L1.47502 22.55Z",
    fill: "#0078D4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.85 23.2C31.55 22.15 31.975 20.9 31.975 19.55C31.975 16.1 29.275 13.3 25.9 13.075C25.9 13.05 25.9 13.025 25.875 13C24.675 12.875 23.575 13.35 23.575 13.35L18.125 15.625L30.85 23.2Z",
    fill: "#1490DF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1251 15.65L23.5751 13.375C23.5751 13.375 24.7001 12.9 25.8751 13.025C24.8251 8.725 20.9251 5.5 16.3001 5.5C12.8001 5.5 9.72507 7.325 7.95007 10.075H7.82507C9.02507 10.225 9.75007 10.65 9.75007 10.65L18.1251 15.65Z",
    fill: "#0364B8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.15 15.65L1.5 22.55L1.525 22.7C2.975 24.725 5.35 26.05 8.025 26.05C8.275 26.05 8.525 26.025 8.775 26.025H25.825C27.925 25.925 29.775 24.825 30.875 23.2L18.15 15.65Z",
    fill: "#28A8EA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnedriveSmall);
export default __webpack_public_path__ + "static/media/onedriveSmall.3eab0aa85556db683dd4f223b206e5e5.svg";
export { ForwardRef as ReactComponent };